import { InputLabel, type TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

import { FormControl, TextField } from '../../index';

const FormControlWrapper = styled(FormControl)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  flexDirection: 'column',
}));

const StyledInputLabel = styled(InputLabel)({
  position: 'relative',
});

const StyledTextarea = styled((props: TextFieldProps) => <TextField {...props} multiline />, {
  shouldForwardProp: (prop) => prop !== 'multiline',
})(({ theme }) => ({
  'textarea.MuiInputBase-inputMultiline': {
    padding: theme.spacing(2.5, 3.5),
  },
  '.MuiInputBase-root': {
    padding: 0,
  },
}));

type TextareaProps = Omit<TextFieldProps<'outlined'>, 'variant' | 'multiline'>;

const Textarea = forwardRef<HTMLDivElement, TextareaProps>(
  (props: Readonly<TextareaProps>, ref) => {
    const { required: isRequired, label, error, ...restProps } = props;

    return (
      <FormControlWrapper required={isRequired}>
        {label ? <StyledInputLabel>{label}</StyledInputLabel> : null}
        <StyledTextarea {...restProps} inputRef={ref} error={!!error} />
      </FormControlWrapper>
    );
  },
);

Textarea.displayName = 'Textarea';

export default Textarea;
export type { TextareaProps };
